var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 128V0H48C21.49 0 0 21.492 0 48V464C0 490.508 21.49 512 48 512H336C362.51 512 384 490.508 384 464V160H256C238.326 160 224 145.672 224 128ZM151.08 432.922C149.125 434.879 146.637 436.207 143.928 436.75L88.379 447.859C83.482 448.84 79.164 444.52 80.143 439.625L91.25 384.082C91.793 381.371 93.125 378.879 95.08 376.926L192.689 279.313L248.695 335.32L151.08 432.922ZM279.391 232.207L295.803 248.621C306.738 259.555 306.736 277.285 295.801 288.219L271.32 312.695L215.314 256.688L239.795 232.207C250.729 221.273 268.457 221.273 279.391 232.207ZM256 0V128H384L256 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePen);
export default __webpack_public_path__ + "static/media/file-pen.cbd43dbbf63365d9267df7f23eb6f394.svg";
export { ForwardRef as ReactComponent };